import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import companyToken from "Utils/companyToken";
import { fetchWithCSRFTokenForRequestObject } from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

import { PartnerPreferences, PartnerPreferencesPayload } from "./partnerPreferences.types";

export const partnerPreferencesApi = createApi({
  reducerPath: "partnerPreferencesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2/",
    fetchFn: fetchWithCSRFTokenForRequestObject,
  }),

  endpoints: (builder) => ({
    updatePartnerPreferences: builder.mutation<PartnerPreferencesPayload, PartnerPreferences>({
      query: (preferences) => ({
        url: appendAuthParams("partner/preferences"),
        method: "PUT",
        body: {
          preferences,
          company_id_token: companyToken(),
        },
      }),
    }),
  }),

  tagTypes: ["PartnerPreference"],
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useUpdatePartnerPreferencesMutation } = partnerPreferencesApi;
